import { isBefore } from "date-fns";
import { formatToUTC } from "./formatters";

export const isDateTodayOrBefore = (value: Date | string | null | undefined) => {
  if (value) {
    const todayInUTC = formatToUTC(new Date());
    const valueInUTC = formatToUTC(new Date(value));
    return value && isBefore(todayInUTC, valueInUTC);
  }
};
